import React from 'react';
import {
  NavigationContainer, NavigationItem, NavigationItemsContainer,
  NavigationSubscriptionButton
} from './UbisoftPlusNavigationStyle';
import { ReactComponent as UbisoftPlusLogo } from '../../assets/ubisoftPlusLogo.svg';
import SubscriptionButton from '../UI/Buttons/SubscriptionButton/SubscriptionButton';
import { withContent } from '../../hoc/withContext';
import { IContent } from '../../types';
import { adobeTrack, getNavigationPageLink, redirectUser } from '../../utils/Functions';
import { INavigationItem } from '../../types/content';
import { useSelector } from 'react-redux';
import { IStore } from '../../types/storeTypes';

interface INavigationProps {
  context?: IContent;
}

function navigationItemClicked(linkKey: string, trackingCode: string) {
  let navigationLink = getNavigationPageLink(linkKey);
  adobeTrack(trackingCode);
  redirectUser(navigationLink);
}

const UbisoftPlusNavigation = ({ context }: INavigationProps) => {
  let app = useSelector((state: IStore) => state.app);
  return (
    <NavigationContainer>
      <UbisoftPlusLogo className={'navigation-logo'} />
      <NavigationItemsContainer>
        {context.navigation.map((item: INavigationItem, index) => {
            let navigationItem = <NavigationItem key={`nav-${item.key}`}
                                                 onClick={() => navigationItemClicked(item.key, item.tracking)}
                                                 isCurrentPage={item.key === 'rewards'}
                                                 isLastItem={context.navigation.length - 1 === index}
            >{item.text}</NavigationItem>;
            if (item.key === 'cloud') {
              if ((app.windowVariablesInitialised) && (app.lunaAvailable || app.stadiaAvailable)) {
                return navigationItem;
              }
            } else {
              return navigationItem;
            }
          }
        )}
      </NavigationItemsContainer>
      <NavigationSubscriptionButton>
        <SubscriptionButton context={''} idToAttach={'navigationSubscription'} />
      </NavigationSubscriptionButton>
    </NavigationContainer>
  );
};

export default withContent(UbisoftPlusNavigation);